function ErrorInfoBox({ title = "", message = "" }) {
  return (
    <>
      {title && message && (
        <div className="error-info-box">
          <h3>{title}</h3>
          <span>{message}</span>
        </div>
      )}
    </>
  );
}

export default ErrorInfoBox;